module.exports = __webpack_public_path__ + "static/Calluna-Semibold-webfont-b3decf04830ce354c8d27479d1f4a4c9.woff2";